import * as React from 'react';
import TestInvestorTypeComponent, { TestInvestorTypeComponentProps } from './AptitudeTestInvestorType.component';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import User from 'src/entities/User';
import { getUser, GetUserAction } from 'src/actions/user/get/GetUser.actions';
import * as getUserTypes from 'src/actions/user/get/Types';
import AptitudeTest from 'src/entities/AptitudeTest';
import { getAptitudeTest, GetAptitudeTestAction } from 'src/actions/aptitude-test/get/GetAptitudeTest.actions';
import FilledAptitudeTest from 'src/entities/FilledAptitudeTest';
import FilledTestSection from 'src/entities/FilledAptitudeTestSection';
import FilledTestQuestion from 'src/entities/FilledAptitudeTestQuestion';
import TestChoice from 'src/entities/AptitudeTestChoice';
import {
  createFilledAptitudeTest,
  CreateFilledAptitudeTestAction,
  CreateFilledAptitudeTestSuccess
} from 'src/actions/filled-test/create/CreateFilledAptitudeTest.actions';
import * as createFilledTestTypes from 'src/actions/filled-test/create/Types';
import { history } from 'src/store';
import LoadingContainer from 'src/modules/commons/loading/Loading.container';
import Person from 'src/entities/Person';
import AptitudeTestChoice from 'src/entities/AptitudeTestChoice';

interface State {
  filledTest?: FilledAptitudeTest;
  success: boolean;
}

interface StateProps {
  user?: User;
  loggedUserData: number | null;
  activeProfile?: Person;
  aptitudeTest?: AptitudeTest;
  error: boolean;
  errorMessage: {};
}

interface DispatchProps {
  getUser(userId: number): Promise<GetUserAction>;

  getAptitudeTest(aptitudeTestName: string): Promise<GetAptitudeTestAction>;

  createFilledAptitudeTest(filledAptitudeTest: FilledAptitudeTest, personId: number, personType: string):
    Promise<CreateFilledAptitudeTestAction>;
}

interface Props extends StateProps, DispatchProps {

}

class AptitudeTestInvestorTypeContainer extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      success: false
    };
  }

  public componentWillMount(): void {
    const userId = this.props.loggedUserData!;
    this.props.getUser(userId).then((response) => {
      if (response.type === getUserTypes.GET_USER_SUCCESS) {
        if (this.props.activeProfile) {
          this.getAptitudeTest(this.props.activeProfile.personType);
        }
      }
    });
  }

  public componentWillReceiveProps(nextProps: StateProps) {
    if (this.props.activeProfile && nextProps.activeProfile &&
      (this.props.activeProfile.id !== nextProps.activeProfile.id ||
        this.props.activeProfile.personType !== nextProps.activeProfile.personType)) {
      history.push('/mi-cuenta/tipo-de-inversor');
    }
  }

  public render(): React.ReactNode {
    return (
      this.props.aptitudeTest ?
        <TestInvestorTypeComponent {...this.getComponentProps()} /> :
        <LoadingContainer/>
    );
  }

  private getAptitudeTest(personType: string): void {
    let aptitudeTestName;
    if (personType === 'physical') {
      aptitudeTestName = 'physical_person_adequacy_test';
    } else if (personType === 'juridical') {
      aptitudeTestName = 'juridical_person_adequacy_test';
    }
    if (aptitudeTestName) {
      this.props.getAptitudeTest(aptitudeTestName).then(() => {
        const filledTest = new FilledAptitudeTest({testId: this.props.aptitudeTest!.id});
        this.props.aptitudeTest!.sections.map(
          (section) => {
            const filledSection = new FilledTestSection({sectionId: section.id});
            section.questions.map(
              (question) => (
                filledSection.questions!.push(new FilledTestQuestion({questionId: question.id,
                  choice: new AptitudeTestChoice({id: 0})}))
              )
            );
            filledTest.sections!.push(filledSection);
          }
        );
        this.setState({filledTest: filledTest});
      });
    }
  }

  private handleChange(section: number, question: number, choice: number): void {
    const test = new FilledAptitudeTest(this.state.filledTest!);
    test.sections!.find(s => s.sectionId === section)!.questions!
      .find(q => q.questionId === question)!.choice = new TestChoice({id: choice});
    this.setState({filledTest: test});
  }

  private handleSubmit(): void {
    this.props.createFilledAptitudeTest(
      this.state.filledTest!,
      this.props.activeProfile!.id,
      this.props.activeProfile!.personType
    ).then((response: CreateFilledAptitudeTestSuccess) => {
        if (response.type === createFilledTestTypes.CREATE_FILLED_APTITUDE_TEST_SUCCESS) {
          history.push('/mi-cuenta/tipo-de-inversor/acreditado/resultados');
        }

      });
  }

  private getComponentProps(): TestInvestorTypeComponentProps {
    return {
      test: this.props.aptitudeTest!,
      handleSubmit: () => this.handleSubmit(),
      handleChange: (section: number, question: number, choice: number) => this.handleChange(section, question, choice),
      error: this.props.error,
      errorMessage: this.props.errorMessage,
      success: this.state.success
    };
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
  getUser: (userId: number): Promise<GetUserAction> => (
    dispatch(getUser(userId))
  ),
  getAptitudeTest: (aptitudeTestName: string): Promise<GetAptitudeTestAction> => (
    dispatch(getAptitudeTest(aptitudeTestName))
  ),
  createFilledAptitudeTest: (filledAptitudeTest: FilledAptitudeTest, personId: number, personType: string):
    Promise<CreateFilledAptitudeTestAction> => (
    dispatch(createFilledAptitudeTest(filledAptitudeTest, personId, personType))
  )
});

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  user: state.getUser.user || undefined,
  loggedUserData: state.authentication.loggedUserData,
  activeProfile: state.setActiveProfile.activeProfile || state.getUser.activeProfile,
  aptitudeTest: state.getAptitudeTest.aptitudeTest || undefined,
  error: state.createFilledAptitudeTest.error,
  errorMessage: state.createFilledAptitudeTest.errorMessage
});

export default connect(mapStateToProps, mapDispatchToProps)(AptitudeTestInvestorTypeContainer);



// WEBPACK FOOTER //
// ./src/modules/my-account/investor-types/aptitude-test/AptitudeTestInvestorType.container.tsx